import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Treatment Planning',
  description: 'Every week you spend hours creating rehabilitation plans, organizing exercise progressions, preparing patient documentation, and adapting treatments for patients with completely different conditions, recovery stages, and goals.'
}, {
  emoji: '⚠️',
  title: "Unsure Whether You're Progressing Too Fast... Or Too Slowly",
  description: 'You constantly wonder if your patients are ready for the next phase of rehabilitation—or if progressing too quickly could delay recovery or increase the risk of setbacks.'
}, {
  emoji: '📚',
  title: 'Information Everywhere',
  description: "Assessment tools. Exercise libraries. Treatment protocols. Documentation templates. Patient education resources. Everything exists—but it's scattered across books, websites, courses, PDFs, and countless folders. Nothing is organized into one complete clinical system you can confidently use every day."
}, {
  emoji: '😩',
  title: 'Mental Burnout',
  description: "Between evaluations, treatment planning, progress documentation, reassessments, patient education, and daily paperwork, there's very little time left to focus on what truly matters: Helping your patients recover and improve their quality of life."
}];
export function PainSection() {
  return <section className="py-12 px-4 sm:px-6 bg-white border-b border-gray-200" data-id="element-129">
      <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-4 uppercase leading-tight" data-id="element-130">
        DOES THIS SOUND FAMILIAR?
      </h2>

      <p className="text-sm sm:text-base text-brand-ink/80 font-medium text-center mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-131">
        You love helping patients recover, but treatment planning is consuming
        your entire week.
        <span className="text-brand-navy font-bold mt-2 block" data-id="element-132">
          If you're a physical therapist working in private practice, outpatient
          rehabilitation, sports medicine, orthopedic clinics, hospitals, or
          rehabilitation centers, you've probably experienced at least one of
          these situations:
        </span>
      </p>

      <div className="flex flex-col gap-5 max-w-2xl mx-auto" data-id="element-133">
        {pains.map((pain, i) => <div key={i} className="bg-brand-paper p-6 rounded-xl border-l-4 border-brand-gold shadow-sm hover:shadow-md transition-shadow flex gap-5 items-start" data-id="element-134">
            <div className="text-3xl leading-none shrink-0 mt-1" data-id="element-135">
              {pain.emoji}
            </div>
            <div data-id="element-136">
              <h3 className="text-base font-bold text-brand-navy mb-2 uppercase tracking-tight" data-id="element-137">
                {pain.title}
              </h3>
              <p className="text-brand-ink/70 text-sm leading-relaxed" data-id="element-138">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}